var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternUiUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#030303",
    strokeWidth: 4,
    cx: 48,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB7565",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 32h4v4H0zM14 32h4v4h-4zM28 32h4v4h-4zM0 46h4v4H0zM14 46h4v4h-4zM28 46h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 60h4v4H0zM14 60h4v4h-4zM28 60h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7F0",
    d: "m32 32 32 32V32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternUiUx);
export default __webpack_public_path__ + "static/media/pattern-ui-ux.19247b7d3a6c0f9e1b7593af951b2773.svg";
export { ForwardRef as ReactComponent };